import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Configure each customer's notification webhooks (platform admin only)
 * @primary Channels table
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/notification-channels/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
